import GroupFilterDto from "../../classes/dtos/datasourcemodule/GroupFilterDto";
import FilterParameterDto from "../../classes/dtos/datasourcemodule/FilterParameterDto";
import FilterParameterValueDto from "../../classes/dtos/datasourcemodule/FilterParameterValueDto";
import FilterParameterVariableDto from "../../classes/dtos/datasourcemodule/FilterParameterVariableDto";
import DataTableFieldParameterDefinitionDto from "../../classes/dtos/datasourcemodule/DataTableFieldParameterDefinitionDto";
import FilterParameterType from "../../classes/consts/DataSourceModule/FilterParameterType";

export default class GroupFilterMapper {

    static ToDto(e: any): GroupFilterDto | null {

        if (e == null) {
            return null;
        }

        return new GroupFilterDto(
            e.id,
            e.operator,
            (e.childrens ?? []).map((c: any) => GroupFilterMapper.ToDto(c)!),
            (e.parameters ?? []).map((p: any) => GroupFilterMapper.ParameterToDto(p)));
    }

    static ParameterToDto(e: any): FilterParameterDto {

        if (e.$type === FilterParameterType.Value) {
            return new FilterParameterValueDto(e.id, e.fieldReferenceId, e.operator, e.value);
        }

        if (e.$type === FilterParameterType.Variable) {
            const definition = e.dataTableFieldParameterDefinition ?? {};
            return new FilterParameterVariableDto(e.id, e.fieldReferenceId, e.operator, definition.technicalName ?? "", definition.id ?? 0);
        }

        throw new Error(e.$type + " not managed");
    }

    // Per-mapping-row simple-mode filter conditions returned by the Path*/GetPath*Detail endpoints:
    // a flat list of filter parameters (every FilterParameterDto subtype, Value and Variable alike).
    static RowFiltersToDtos(e: any): FilterParameterDto[] {
        return (e ?? []).map((p: any) => GroupFilterMapper.ParameterToDto(p));
    }

    // Update payload for the per-row simple-mode conditions (mapping.Filters).
    static RowFiltersToPayload(filters: FilterParameterDto[] | null | undefined): object[] {
        return (filters ?? []).map((f) => GroupFilterMapper.ParameterToPayload(f));
    }

    // Per-mapping-row complex-mode declared variables (mapping.DeclaredVariables), independent from the
    // simple-mode conditions above. The backend sends only { id, technicalName } per declaration.
    static DeclaredVariablesFromResponse(declaredVariables: any): DataTableFieldParameterDefinitionDto[] {
        return (declaredVariables ?? []).map((d: any) =>
            new DataTableFieldParameterDefinitionDto(d.id ?? 0, d.technicalName ?? ""));
    }

    // Update payload for the per-row complex-mode declared variables.
    static DeclaredVariablesToPayload(declaredVariables: DataTableFieldParameterDefinitionDto[] | null | undefined): object[] {
        return (declaredVariables ?? []).map((d) => ({ Id: d.Id, TechnicalName: d.TechnicalName }));
    }

    static ToPayload(e: GroupFilterDto | null): object | null {

        if (e == null) {
            return null;
        }

        return {
            Id: e.Id,
            Operator: e.Operator,
            Childrens: e.Childrens.map((c) => GroupFilterMapper.ToPayload(c)),
            Parameters: e.Parameters.map((p) => GroupFilterMapper.ParameterToPayload(p))
        };
    }

    static ParameterToPayload(e: FilterParameterDto): object {

        if (e instanceof FilterParameterValueDto) {
            return {
                $type: FilterParameterType.Value,
                Id: e.Id,
                FieldReferenceId: e.FieldReferenceId,
                Operator: e.Operator,
                Value: e.Value
            };
        }

        if (e instanceof FilterParameterVariableDto) {
            return {
                $type: FilterParameterType.Variable,
                Id: e.Id,
                FieldReferenceId: e.FieldReferenceId,
                Operator: e.Operator,
                DataTableFieldParameterDefinition: {
                    Id: e.DataTableFieldParameterDefinition.Id,
                    TechnicalName: e.DataTableFieldParameterDefinition.TechnicalName
                }
            };
        }

        throw new Error("FilterParameterDto of unknown type is not managed");
    }
}
